import React from 'react';
import styled from 'styled-components';
import Wrapper from './Wrapper';

const Container = styled.div`
    border: 1px solid #E2E4E8;
    border-radius: 16px;
    overflow: hidden;
    min-height: 588px;
    width: 100%;
    height: 100%;
`
const Table = (props) => {
    const { children, className } = props;
    return (
        <Container className={className}>
            <Wrapper className="table table-striped">
                {children}
            </Wrapper>
        </Container>
    )
}

export default Table;